@if (ownAds !== null) {
  <div class="flex flex-col items-center">
    @if (ownAds.ads.length === 0) {
      <div  class="flex flex-col mb-7 justify-center items-center">
        <img class="mx-16 mt-16 md:w-96 md:h-auto" src="assets/images/404.svg" alt="404-Logo">
        <span class="mx-[84px] mt-8 font-medium text-base text-[#A7A7A7] text-center">Bisher noch ziemlich<br>leer hier.</span>
      </div>
    }
    @if (ownAds.ads.length === 0) {
      <kaz-button class="text-kaz-blue mt-5 w-full md:w-[343px]" routerLink="/entry/create" buttonType="bordered" text="Anzeige aufgeben"></kaz-button>
    }
    <!-- Divider -->
    <div class="my-5 border-t border-[#EFEFEF] md:hidden"></div>
    @if (ownAds.ads.length > 0) {
      <span class="hidden md:flex md:text-xl md:text-kaz-black md:font-semibold md:mb-7">Archivierte Anzeigen</span>
    }
    <div class="flex flex-col gap-2 md:grid md:grid-cols-2 md:gap-[72px]">
      @for (ad of ownAds.ads; track ad) {
        <div>
          <kaz-card-archive-ads [ad]="ad" (wasDeleted)="refreshArchivedAds()"></kaz-card-archive-ads>
        </div>
      }
    </div>
  </div>
}
